export default "/profile/images/bitrixUA.png?6cce55bf0292b8f80a6256196cdb479a";